<template>
  <div class="ci-container">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'container'
}
</script>



// WEBPACK FOOTER //
// container.vue?f0fd2eb6